// src/components/BetSlipFloatingButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBetSlip } from '../context/BetSlipContext';

const BetSlipFloatingButton = ({ count, onClick }) => {
  const navigate = useNavigate();
  const { bets } = useBetSlip();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/betslip');
    }
  };

  const calculateTotalOdds = () => {
    if (bets.length === 0) return 0;
    return bets.reduce((acc, bet) => acc * bet.odds, 1).toFixed(2);
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-40 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white p-4 rounded-full shadow-lg flex items-center justify-center animate-bounce-slow transition-all duration-300 group"
      aria-label={`Open betslip with ${count} items`}
    >
      {/* Badge */}
      <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
        {count}
      </div>
      
      {/* Icon */}
      <div className="relative">
        <span className="text-xl">📋</span>
      </div>
      
      {/* Tooltip */}
      <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        <div className="bg-gray-900 text-white text-sm rounded-lg px-3 py-2 whitespace-nowrap shadow-xl">
          <div className="font-bold mb-1">Betslip ({count})</div>
          <div className="text-green-400">Total odds: {calculateTotalOdds()}</div>
          <div className="text-xs text-gray-400">Click to view</div>
        </div>
      </div>
    </button>
  );
};

export default BetSlipFloatingButton;